import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { IListOrder, IOrder } from 'types/income';
import { TableDataResponse } from 'types/general';
import { exportXlsxConfig } from 'utils/general';
import { OrderStatus, OrdersFilters } from './orders.types';

const getFilters = (filters: Partial<OrdersFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  filter: {
    creationDateFrom: filters.createdAt?.from,
    creationDateTo: filters.createdAt?.to,
    expenseDateFrom: filters.expenseDate?.from,
    expenseDateTo: filters.expenseDate?.to,
    employee: filters.employees,
    companyIds: filters.companies,
    supplierIds: filters.suppliers,
    itemIds: filters.items,
    orderId: filters.orders,
    status: filters.status,
    isInternalItem:
      filters.variant === 'melp-shop'
        ? false
        : filters.variant === 'internal'
        ? true
        : undefined,
    search: filters.search || undefined,
  },
});

interface GetOrders {
  filters: Partial<OrdersFilters>;
}

interface GetOrder {
  orderId: string;
}

interface UpdateOrder {
  orderId: string;
  data: {
    couponFileId: string;
    couponCode: string;
    barcode: string;
    status: OrderStatus;
    commentForAdmin: string;
    commentForEmployee: string;
  };
}

interface BulkEdit {
  orderIds: string[];
  status: OrderStatus;
  commentForEmployee?: string;
}

interface ExportXls {
  filters: Partial<OrdersFilters>;
}

export const loaders = {
  getOrders: ({ filters }: GetOrders) => {
    return api<TableDataResponse<IListOrder>>({
      url: Endpoints.clientAdmin.orders.root,
      params: getFilters(filters),
    });
  },
  getOrder: ({ orderId }: GetOrder) => {
    return api<IOrder>({
      url: Endpoints.clientAdmin.orders.byId.replace(':orderId', orderId),
    });
  },
  updateOrder: ({ orderId, data }: UpdateOrder) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.orders.byId.replace(':orderId', orderId),
      data,
      method: 'patch',
    });
  },
  bulkEdit: ({ orderIds, status, commentForEmployee }: BulkEdit) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.orders.bulk.edit,
      data: {
        ids: orderIds,
        status,
        commentForEmployee,
      },
      method: 'patch',
    });
  },
  exportXls: ({ filters }: ExportXls) => {
    return api({
      url: Endpoints.clientAdmin.orders.export.xls,
      params: {
        filter: getFilters(filters).filter,
      },
      ...exportXlsxConfig,
    });
  },
};
